export const siteStats = [
  {
    label: "在追事件",
    value: "68",
    note: "处于持续推进状态",
  },
  {
    label: "已归档进展",
    value: "1,240+",
    note: "条经过时间排序的节点",
  },
  {
    label: "平均更新间隔",
    value: "3.2 小时",
    note: "热度越高跟进越密",
  },
  {
    label: "年份跨度",
    value: "2019 至今",
    note: "长期事件也可回看",
  },
];

export const siteFeatures = [
  {
    title: "时间线优先",
    desc: "把散落在各处的说法按发生顺序排列，先看清顺序，再判断真假。",
    icon: "ri-timeline-view",
  },
  {
    title: "状态标记",
    desc: "每条档案都标注「发酵中 / 已回应 / 已澄清 / 持续追踪」，一眼知道进展到哪一步。",
    icon: "ri-price-tag-3-line",
  },
  {
    title: "热度曲线",
    desc: "用统一的热度值衡量讨论规模，帮助区分真正的公共话题与短暂的情绪浪花。",
    icon: "ri-line-chart-line",
  },
  {
    title: "来源标注",
    desc: "每个节点都写明是官方回应、当事方说明还是公开报道，不做无出处的转述。",
    icon: "ri-links-line",
  },
];